module.exports = __webpack_public_path__ + "media/images/icon__link@2x-3a4dada7e7dcd8f0d7ef4ef4eb6b3472.png";